<template>
  <div id="edit-address">
    <div id="BMap"></div>
    <van-notice-bar text="新增或修改地址时，需要填入固话号码请在联系电话前加区号。" mode="closeable"
                    :left-icon="require('../../assets/icon_notice.png')"></van-notice-bar>
    <van-cell-group>
      <van-field label="姓名" placeholder="请输入姓名" v-model="addressInfo.name"/>
      <van-field label="联系电话" placeholder="请输入联系电话" type="tel" v-model="addressInfo.concatPhone" maxlength="12"/>
      <van-cell is-link title="地区" :value="addressInfo.area" @click="showArea"></van-cell>
      <van-cell v-show="regionBtnShow" is-link title="服装城" :value="addressInfo.clothingCityName"
                @click="showRegion"></van-cell>
      <van-field label="详细地址" placeholder="请输入详细地址" @input="detailAddressInput" v-model="addressInfo.address"/>
      <!-- 隐藏 -->
      <van-field label="详细地址" v-show="false" id="detailAddress" v-model="addressInfo.address" icon="location"
                 @click-icon="getLocation"/>
      <!-- &lt;!&ndash; 详细地址搜索框 &ndash;&gt; -->
      <van-cell v-for="(item,index) in searchResult" :key="index" @click="selectAddress(index)" :title="item.name"
                :label="item.address" icon="location" clickable></van-cell>
      <van-cell v-show="!btnShow">
        <van-button size="mini" style="float:right" @click="emptySearchResult">关闭</van-button>
      </van-cell>
      <!-- 确认按钮 -->
      <div class="btn-submit">
        <van-button type="danger" size="large" @click="onSave">保存</van-button>
        <van-button size="large" @click="onDel" v-if="delShow">删除</van-button>
      </div>
      <!-- 省市区弹出框 -->
      <van-popup v-if="type=='1'" v-model="cityShow" position="bottom">
        <van-area :area-list="areaList" :value="addressInfo.areaId.toString()" @cancel="cancelArea"
                  @confirm="confirmArea"/>
      </van-popup>
      <van-popup v-if="type=='2'" v-model="cityShow" position="bottom">
        <van-area :area-list="areaList" :value="addressInfo.areaId.toString()" @cancel="cancelArea"
                  @confirm="confirmArea" :columns-num="2"/>
      </van-popup>
      <!-- 服装城弹出框 -->
     <van-popup  v-model="regionShow" position="bottom">
       <van-cell-group>
         <van-cell>
           <div slot="title" class="popup-title">
             <span>服装城选择</span>
             <van-button size="mini" type="danger" @click="emptyRegion">清空</van-button>
           </div>
           <div slot="right-icon" @click="closeRegion">
             <van-icon name="close" size="0.5rem"/>
           </div>
         </van-cell>
       </van-cell-group>
       <van-search placeholder="请输入要查询的服装城" v-model="searchKey">
       </van-search>
       <div class="region-list">
         <!-- &lt;!&ndash; 服装城列表 &ndash;&gt; -->
         <van-cell v-for="item in filterRegion" :key="item.id" @click="selectRegion(item.id)"
                   :class="{active:item.active}" clickable>
           <div class="region-name" slot="title">{{item.name}}</div>
         </van-cell>
       </div>
     </van-popup>
    </van-cell-group>
  </div>
</template>

<script>
import { Dialog, Toast } from "vant";
import "../../utils/city.js";
import { city } from "../../utils/city.js";

export default {
  name: "EditAddress",
  data() {
    return {
      // 地图
      BMap: null,
      // 自动完成对象
      ac: null,
      // 搜索结果
      searchResult: [],
      // 地址信息
      addressInfo: {
        id: "",
        name: "",
        concatPhone: "",
        provinceName: "河北省",
        provinceId: "130000",
        cityName: "石家庄市",
        cityId: "130100",
        districtName: "新华区",
        districtId: "130105",
        address: "",
        clothingCityName: "",
        clothingCityId: "",
        lat: "",
        lng: "",
        deliverer: "",
        idCardNumber: "",
        area: "河北省 石家庄市 新华区",
        areaId: "130105",
        addressDefault: 0,
        type: ""
      },
      // 默认地址
      DefaultInfo: {
        id: "",
        name: "",
        concatPhone: "",
        provinceName: "河北省",
        provinceId: "130000",
        cityName: "石家庄市",
        cityId: "130100",
        districtName: "新华区",
        districtId: "130105",
        address: "",
        clothingCityName: "",
        clothingCityId: "",
        lat: "",
        lng: "",
        deliverer: "",
        idCardNumber: "",
        area: "河北省 石家庄市 新华区",
        areaId: "130105",
        addressDefault: 0,
        type: ""
      },
      // 地址列表
      areaList: {},
      // 服装城按钮显示
      regionBtnShow: true,
      // 服装城显示
      regionShow: false,
      // 服装城搜索关键词
      searchKey: "",
      // 服装城列表
      regionList: [],
      // 服装城选中索引
      regionIndex: -1,
      // 确定前服装城索引
      nextRegionIndex: -1,
      // 省市区显示
      cityShow: false,
      // 按钮显示
      btnShow: true,
      // 删除按钮显示
      delShow: false,
      type: this.$route.params.type
    };
  },
  created() {
    this.areaList = city;
  },
  computed: {
    filterRegion() {
      let searchKey = this.searchKey;
      let arr = [];
      this.regionList.forEach(item => {
        if (item.name.indexOf(searchKey) !== -1) {
          arr.push(item);
        }
      });
      return arr;
    }
  },
  mounted() {
    if (this.$route.params.type === "2") {
      this.regionBtnShow = false;
      this.$store.commit({
        type: "setTitle",
        title: "新增收货人"
      });
      this.DefaultInfo = {
        id: "",
        name: "",
        concatPhone: "",
        provinceName: "",
        provinceId: "",
        cityName: "",
        cityId: "",
        districtName: "",
        districtId: "",
        address: "",
        clothingCityName: "",
        clothingCityId: "",
        lat: "",
        lng: "",
        deliverer: "",
        idCardNumber: "",
        area: "",
        areaId: "440106",
        addressDefault: 0,
        type: ""
      }
    } else {
      this.$store.commit({
        type: "setTitle",
        title: "新增寄件人"
      });
      this.DefaultInfo = {
        id: "",
        name: "",
        concatPhone: "",
        provinceName: "河北省",
        provinceId: "130000",
        cityName: "石家庄市",
        cityId: "130100",
        districtName: "新华区",
        districtId: "130105",
        address: "",
        clothingCityName: "",
        clothingCityId: "",
        lat: "",
        lng: "",
        deliverer: "",
        idCardNumber: "",
        area: "河北省 石家庄市 新华区",
        areaId: "130105",
        addressDefault: 0,
        type: ""
      }
    }
    this.setMap();
    // this.setAutocomplete();
    this.getAddress();
  },
  watch: {
    searchResult(val) {
      this.btnShow = val.length === 0 ? true : false;
    },
    regionShow(val) {
      if (!val) {
        this.searchKey = "";
      }
    }
  },
  methods: {
    // 获取信息
    getAddress() {
      this.addressInfo = this.DefaultInfo;
      // 如果是增加地址
      if (this.$route.name === "AddAddress") {
        this.delShow = false;
        this.searchResult = [];
        this.addressInfo.type = this.$route.params.type;
      } else {
        let params = { params: this.$route.params.id };
        this.$axios.post("merchantConcat/getAddress", params).then(res => {
          if (res.data.code === 200) {
            let data = res.data.data;
            Object.keys(this.addressInfo).forEach(key => {
              this.addressInfo[key] = data[key];
            });
            this.addressInfo.area =
              data.provinceName + " " + data.cityName + " " + data.districtName;
            this.addressInfo.areaId = data.districtId;
            if (
              this.addressInfo.address.indexOf(
                this.addressInfo.clothingCityName
              ) !== -1
            ) {
              this.addressInfo.address = this.addressInfo.address.substring(
                this.addressInfo.clothingCityName.length,
                this.addressInfo.address.length
              );
            }
          }
        });
      }
    },
    // 弹出地址选择器
    showArea() {
      this.cityShow = true;
    },
    // 取消地址选择器
    cancelArea() {
      this.cityShow = false;
    },
    // 确认地址选择器
    confirmArea(data) {
      this.addressInfo.lat = 0;
      this.addressInfo.lng = 0;
      this.addressInfo.provinceName = data[0].name;
      this.addressInfo.provinceId = data[0].code;
      this.addressInfo.cityName = data[1].name;
      this.addressInfo.cityId = data[1].code;
			console.log(this.addressInfo.cityId)
      this.addressInfo.districtName = data[2] ? data[2].name : '';
      this.addressInfo.districtId = data[2] ? data[2].code : '';
      this.addressInfo.area = data[0].name + " " + data[1].name;
      data[2] &&( this.addressInfo.area = data[0].name + " " + data[1].name + " " + data[2].name);
      this.addressInfo.areaId = data[2] ? data[2].code : data[1].code;
      this.cityShow = false;
      this.addressInfo.address = "";
      this.addressInfo.clothingCityName = "";
      this.addressInfo.clothingCityId = "";
      this.searchResult = [];
      this.setMap();
      // this.ac.dispose();
      // this.setAutocomplete();
    },
    // 弹出服装城
    showRegion() {
      this.regionShow = true;
      this.getRegionList();
    },
    // 获取服装城列表
    getRegionList() {
      let params = {
        params: {
          provinceId: this.addressInfo.provinceId,
          cityId: this.addressInfo.cityId,
          districtId: this.addressInfo.districtId
        }
      };
      this.$axios.post("merchant/getMarkets", params).then(res => {
        if (res.data.code === 200) {
          let data = res.data.data;
          data.forEach(item => {
            item.active = false;
            if (item.id === this.addressInfo.clothingCityId) {
              item.active = true;
            }
          });
          this.regionList = res.data.data;
        }
      });
    },
    // 选择服装城
    selectRegion(id) {
      this.addressInfo.address = "";
      this.searchResult = [];
      this.regionList.forEach(val => {
        if (val.id === id) {
          val.active = true;
          if (val.active) {
            this.addressInfo.lat = val.lat;
            this.addressInfo.lng = val.lng;
            this.addressInfo.clothingCityId = id;
            this.addressInfo.clothingCityName = val.name;
          } else {
            this.addressInfo.lat = 0;
            this.addressInfo.lng = 0;
            this.addressInfo.clothingCityId = "";
            this.addressInfo.clothingCityName = "";
          }
        }
      });
      this.regionShow = false;
    },
    // 关闭服装城
    closeRegion() {
      this.regionShow = false;
    },
    // 清空服装城
    emptyRegion() {
      this.addressInfo.lat = 0;
      this.addressInfo.lng = 0;
      this.addressInfo.clothingCityId = "";
      this.addressInfo.clothingCityName = "";
      this.regionShow = false;
    },
    // 选择详细地址搜索结果
    selectAddress(index) {
      let oldArea =
        this.addressInfo.provinceName +
        " " +
        this.addressInfo.cityName +
        " " +
        this.addressInfo.districtName;
      let info = this.searchResult[index];
      this.addressInfo.address = info.address + info.name;
      this.getPoint(this.addressInfo.address, info.city);
      this.addressInfo.cityName = info.city;
      this.addressInfo.districtName = info.district;
      for (let key in city.city_list) {
        if (city.city_list[key] === info.city) {
          this.addressInfo.cityId = key;
          break;
        }
      }
      for (let key in city.county_list) {
        if (city.county_list[key] === info.district) {
          this.addressInfo.districtId = key;
          break;
        }
      }
      this.addressInfo.provinceId =
        this.addressInfo.districtId.slice(0, 2) + "0000";
      for (let key in city.province_list) {
        if (this.addressInfo.provinceId === key) {
          this.addressInfo.provinceName = city.province_list[key];
          break;
        }
      }
      this.addressInfo.area =
        this.addressInfo.provinceName + " " + info.city + " " + info.district;
      this.addressInfo.areaId = this.addressInfo.districtId;
      if (oldArea !== this.addressInfo.area) {
        this.addressInfo.clothingCityId = "";
        this.addressInfo.clothingCityName = "";
      }
    },
    detailAddressInput() {
      if (this.addressInfo.clothingCityId === "") {
        this.addressInfo.lat = 0;
        this.addressInfo.lng = 0;
      }
    },
    // 清空搜索结果
    emptySearchResult() {
      this.searchResult = [];
    },
    // 保存地址
    onSave() {
      let info = this.addressInfo;
      if (info.name === "") {
        Dialog.alert({
          title: "温馨提示",
          message: "姓名不能为空！"
        }).then(() => {
          return false;
        });
        return;
      }
      if (info.concatPhone === "") {
        Dialog.alert({
          title: "温馨提示",
          message: "联系电话不能为空！"
        }).then(() => {
          return false;
        });
        return false;
      }
      let telReg1 = !!info.concatPhone.match(
        /^(0|86|17951)?(13[0-9]|15[012356789]|166|199|17[5678]|18[0-9]|14[57])[0-9]{8}$/
      );
      let telReg2 = !!info.concatPhone.match(
        /^(0[0-9]{2,3})([2-9][0-9]{6,7})+(-[0-9]{1,4})?$/
      );
      if (!telReg1 && !telReg2) {
        Dialog.alert({
          title: "温馨提示",
          message: "请输入正确手机号！"
        }).then(() => {
          return false;
        });
        return false;
      }
      if (!info.provinceId || !info.cityId) {
        Dialog.alert({
          title: "温馨提示",
          message: "请选择省市区！"
        }).then(() => {
          return false;
        });
        return false;
      }
      if (info.address === "") {
        Dialog.alert({
          title: "温馨提示",
          message: "详细地址不能为空！"
        }).then(() => {
          return false;
        });
        return false;
      }
      if (this.$route.name === "AddAddress") {
        let address = {
          address: info.address,
          addressDefault: "0",
          provinceId: info.provinceId,
          provinceName: info.provinceName,
          cityId: info.cityId,
          cityName: info.cityName,
          districtId: info.districtId,
          districtName: info.districtName,
          concatPhone: info.concatPhone,
          clothingCityId: info.clothingCityId,
          clothingCityName: info.clothingCityName,
          lat: info.lat || 0,
          lng: info.lng || 0,
          name: info.name,
          streetId: info.streetId,
          streetName: info.streetName,
          type: info.type
        };
        let params = { params: address };
        this.$axios.post("merchantConcat/addAddress", params).then(res => {
          if (res.data.code === 200) {
            Dialog.alert({
              title: "温馨提示",
              message: "新增成功！"
            }).then(() => {
              this.$router.go(-1);
              return;
            });
          }
        });
      } else {
        info.address = info.clothingCityName + info.address;
        let address = {
          address: info.address,
          addressDefault: info.addressDefault,
          provinceId: info.provinceId,
          provinceName: info.provinceName,
          cityId: info.cityId,
          cityName: info.cityName,
          districtId: info.districtId,
          districtName: info.districtName,
          id: info.id,
          concatPhone: info.concatPhone,
          clothingCityId: info.clothingCityId || "",
          clothingCityName: info.clothingCityName || "",
          lat: info.lat || 0,
          lng: info.lng || 0,
          name: info.name,
          streetId: info.streetId || "",
          streetName: info.streetName || "",
          type: info.type
        };
        let params = { params: address };
        this.$axios.post("merchantConcat/modifyAddress", params).then(res => {
          if (res.data.code === 200) {
            let list = [];
            if (this.$route.params.type === "1") {
              list = this.$store.state.sendList;
            } else if (this.$route.params.type === "2") {
              list = this.$store.state.acceptList;
            }
            list.forEach((val, i) => {
              if (val.id === info.id) {
                this.$store.commit({
                  type: "modifyAddress",
                  index: i,
                  address: info,
                  t: this.$route.params.type
                });
                if (this.length === 1) {
                  return;
                }
                let j = list.length > 1 && list[0].id === info.id ? 1 : 0;
                let item = info;
                let lat = list[j].lat;
                let lng = list[j].lng;
                let clothingCityId = list[j].clothingCityId;
                let provinceName = list[j].provinceName;
                let cityName = list[j].cityName;
                let districtName = list[j].districtName;
                if (
                  lat !== 0.0 &&
                  lng !== 0.0 &&
                  item.lat !== 0.0 &&
                  item.lng !== 0.0
                ) {
                  let obj1 = { lat, lng };
                  let obj2 = { lat: item.lat, lng: item.lng };
                  if (this.radLat(obj1, obj2) <= 3) {
                    return;
                  }
                } else if (
                  clothingCityId !== "" &&
                  item.clothingCityId === clothingCityId
                ) {
                  return;
                } else if (
                  provinceName === item.provinceName &&
                  cityName === item.cityName &&
                  districtName === item.districtName
                ) {
                  return;
                }
                this.$store.commit({
                  type: "unselAddress",
                  index: i,
                  t: this.$route.params.type
                });
              }
            });
            this.$router.go(-1);
          }
        });
      }
    },
    /*------------------------------*/
    /*------- 百度地图API开始 -------*/
    /*------------------------------*/
    // 初始化地图
    setMap() {
      this.BMap = new BMap.Map("BMap");
      this.BMap.centerAndZoom(this.addressInfo.cityName, 12);
    },
    // 自动完成对象(输入地址提示)
    setAutocomplete() {
      this.ac = new BMap.Autocomplete({
        input: "detailAddress",
        location: this.BMap,
        onSearchComplete: () => {
          this.ac.hide();
          this.searchResult = [];
          for (let i = 0; this.ac.getResults().getPoi(i); i++) {
            let value = this.ac.getResults().getPoi(i);
            this.searchResult.push({
              name: value.business,
              address: value.city + value.district,
              city: value.city,
              district: value.district
            });
          }
        }
      });
    },
    // 获取当前地址
    getLocation() {
      let that = this;
      let oldArea =
        this.addressInfo.provinceName +
        " " +
        this.addressInfo.cityName +
        " " +
        this.addressInfo.districtName;
      let geolocation = new BMap.Geolocation();
      geolocation.getCurrentPosition(
        function(r) {
          if (this.getStatus() == BMAP_STATUS_SUCCESS) {
            that.addressInfo.provinceName = r.address.province;
            that.addressInfo.cityName = r.address.city;
            that.addressInfo.districtName = r.address.district;
            that.addressInfo.area =
              r.address.province +
              " " +
              r.address.city +
              " " +
              r.address.district;
            that.addressInfo.address = r.address.street;
            that.addressInfo.lat = r.point.lat;
            that.addressInfo.lng = r.point.lng;
            let pId;
            for (let key in city.province_list) {
              if (city.province_list[key] === r.address.province) {
                that.addressInfo.provinceId = key;
                pId = key.substr(0, 2);
                break;
              }
            }
            for (let key in city.city_list) {
              if (
                city.city_list[key] === r.address.city &&
                key.substr(0, 2) === pId
              ) {
                that.addressInfo.cityId = key;
                break;
              }
            }
            for (let key in city.county_list) {
              if (
                city.county_list[key] === r.address.district &&
                key.substr(0, 2) === pId
              ) {
                that.addressInfo.districtId = key;
              }
            }
            if (oldArea !== that.addressInfo.area) {
              that.addressInfo.clothingCityId = "";
              that.addressInfo.clothingCityName = "";
            }
          } else {
            Toast({
              message: "获取位置信息失败，请刷新后重试",
              duration: 2000
            });
          }
        },
        {
          enableHighAccuracy: true
        }
      );
    },
    // 解析经纬度
    getPoint(address, city) {
      var that = this;
      let geoc = new BMap.Geocoder();
      geoc.getPoint(
        address,
        point => {
          if (point) {
            that.addressInfo.lat = point.lat;
            that.addressInfo.lng = point.lng;
          } else {
            that.addressInfo.lat = 0;
            that.addressInfo.lng = 0;
          }
        },
        city
      );
    },
    // 计算省市区距离
    rad(lat) {
      return (lat * Math.PI) / 180;
    },
    radLat(obj1, obj2) {
      let lat1 = obj1.lat,
        lng1 = obj1.lng,
        lat2 = obj2.lat,
        lng2 = obj2.lng;
      let a = this.rad(lat1) - this.rad(lat2);
      let b = this.rad(lng1) - this.rad(lng2);
      let s =
        2 *
        Math.asin(
          Math.sqrt(
            Math.pow(Math.sin(a / 2), 2) +
              Math.cos(this.rad(lat1)) *
                Math.cos(this.rad(lat2)) *
                Math.pow(Math.sin(b / 2), 2)
          )
        );
      s = s * 6378.137;
      s = Math.round(s * 10000) / 10000;
      s = parseInt(s);
      return s;
    }
    /*------------------------------*/
    /*------- 百度地图API结束 -------*/
    /*------------------------------*/
  }
};
</script>

<style scoped lang="scss">
#edit-address {
  .van-icon {
    transform: translateY(3px);
    margin-left: 0.25rem;
  }
  .btn {
    padding: 0.25rem;
  }
  .btn-submit {
    padding: 0.25rem;
    .van-button--default {
      margin-top: 0.25rem;
    }
  }
  .popup-title {
    display: flex;
    align-items: center;
    .van-button {
      margin-left: 0.25rem;
    }
  }
  .region-list {
    overflow-y: scroll;
    overflow-x: hidden;
    padding: 0.25rem 0.25rem 0;
		height: 9rem;
    padding-bottom: 0.25rem;
    .active {
      background-color: #ccc;
      border-radius: 5px;
    }
    .region-name {
      text-align: center;
    }
  }
}
</style>
